// eslint-no-undef
import React from 'react';
import {ellipses} from '../Helpers';
import '../App.css';

// This class represents the small conversation box on the left in the
//  list of conversations. It contains user information and an avatar
//   in the case of 1:1 conversations.
export default class Convo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  showProfile(e, user) {
    if (e.target.id === 'user') {
      e.preventDefault();
      this.props.app.hideStuff(e);
      this.props.app.setState({profile: user, post: ''});
    }
  }

  handleMouseOver(event) {
    this.setState({hovered: true});
  }

  handleMouseOut(event) {
    this.setState({hovered: false});
  }

  render() {
    let title = this.state.title || this.props.title || '';
    if (!title) {
      title = this.props.conversation.users.filter(x => x.username !== this.props.current_user.username).map(y => y.username).join(', ');
    }
    let message = this.props.conversation['latest_message'];
    if (message) {
      let body = message.body;
      if (typeof message.body === 'object') {
        body = message.body.text;
      }
      message = `${message.user.username}: ${ellipses(body)}`;
    }
    if (this.props.unreadMessage) {
      message = <span className='unreadMessageSpan'>{message}</span>;
    }
    let divId = 'conversation_' + this.props.conversation._id['$oid'];
    return (
      <div id={divId} onMouseOver={(e) => this.handleMouseOver(e)} onMouseOut={(e) => this.handleMouseOut(e)} className='convo'
                             style={{border: this.props.selected ? 'solid 2px #01aef0' : 'solid 1px #c7c9cb',
                             backgroundColor: this.state.hovered ? '#e7e8e9' : this.props.conversation.area_id ? '#AFEFFF' : '#ffffff'}}
                             onClick={() => this.props.selectConversation(this.props.conversation._id.$oid)}>
        {( this.props.avatar && this.props.conversation.users.length < 3 && !this.props.conversation.area_id) ? <img src={this.props.avatar} className='avatar' alt='' /> : ''}
          &nbsp;{ellipses(title, 29)}
        <div className='smallGreyFont'>
          {message || ''}
        </div>
      </div>
    );
  }
}
